import 'ui-core/plugins/drawer/js/drawer';

(function (UX) {
    var menu = UX.menu,
        $window = $(window),
        $body = $('body'),
        $header = $('header.header'),
        tabKey = 9,
        escKey = 27,
        enterKey = 13;

    menu.listPositionVars.mainScrollingList = $('.drawer__nav');
    menu.listPositionVars.bodyTransitionPropertyName = 'width';
    menu.listPositionVars.bodyTransitionElapsedTime = 0.2;
    menu.listPositionVars.inTimeoutTiming = 100;
    menu.listPositionVars.outTimeoutTiming = 50;

    menu.on.show = function (e) {
        if (typeof UX.controller !== 'undefined') {
            UX.controller.check();
        }
        if (e) {
            $(e.target).closest('.main-nav').addClass('js--open');
        }
        $body.addClass('lock-screen').attr('data-active', 'menu');

        menu.$toggle.addClass('js--open');
        menu.$target.attr('style', 'display: block !important');
        $('.main-nav__toggle__controller').attr('aria-expanded', 'true');
    };
    menu.on.hide = function (e) {
        menu.on.listPosition.reset();
        $header.find('.header--first-row').css('transform', '');
        menu.$toggle.removeClass('js--open');
        $body.removeAttr('data-active').removeClass('lock-screen');
        menu.$target.attr('style', '');
        $('.main-nav__toggle__controller').attr('aria-expanded', 'false');
        if (e) {
            $(e.target).closest($header).find('.main-nav').removeClass('js--open');
        }
    };
    menu.on.showNestedExtra = function () {
        menu.$target.addClass('sub-menu__opened');
    };
    menu.on.hideNestedExtra = function () {
        if (!$('.menu-parent__opened').length) {
            menu.$target.removeClass('sub-menu__opened');
        }
    };
    menu.control = function () {
        $body.on('click', '[data-toggle="nav"]', function (e) {
            e.preventDefault();
            menu.$toggle = $(this);
            menu.$target = $('#' + menu.$toggle.data('target'));

            menu.items = menu.$target.find('a, button, input'); //$(".header__nav a, .header__nav button, .header__nav input");
            menu.items.each(function (index) {
                if (index === menu.items.length - 1) {
                    menu.lastItem = $(this);
                }
            });

            menu.on.show(e);
        });

        $body.on('click', '.js--open[data-toggle="nav"]', function (e) {
            e.preventDefault();
            menu.on.hide(e);
        });

        $body.on('click', function (e) {
            if (!$(e.target).closest('.dropdown__toggle').length) {
                $('a.dropdown__toggle.hover').removeClass('hover');
            }
            if (
                !$(e.target).hasClass('icon-arrow_r') &&
                !$(e.target).parents('.main-nav__toggle__controller') &&
                !$(e.target).parents('.main-nav.menu--res').length &&
                $('.lock-screen[data-active="menu"]').length
            ) {
                menu.on.hide(e);
            }
        });

        $body.on('click', '.main-nav a', function (e) {
            if ($(this).attr('href') === '#') {
                e.preventDefault();
            }
        });

        $body.on('click', '[data-toggle="dropdown"]', function (e) {
            e.preventDefault();
            menu.nestedMenu = $(this);
            menu.on.nested(e);
        });
        $body.on('click', '.menu-header', function (e) {
            e.preventDefault();

            if (menu.isMobile) {
                menu.on.hideNested(true);
            }
            e.stopPropagation(); // prevent closing menu when getting back from nested menu
        });
        $body.on('keydown', '.drawer__nav, [data-toggle="nav"]', function (e) {
            if (menu.isMobile) {
                if ((e.keyCode || e.which) === tabKey) {
                    if (!menu.revers) {
                        menu.on.tab();
                    } else {
                        menu.on.tabRevers();
                    }
                }
            }
        });

        $('.main-nav').each((i, $elem) =>
            $elem.addEventListener('transitionend', menu.on.listPosition.handleHeightSet)
        ); // <-- this is the difference between photo and core
        $window.on('resize', menu.on.listPosition.handleResize);

        $window.on('keyup', function (e) {
            menu.revers = !!(e.shiftKey && e.keyCode === tabKey);
            if (!menu.isMobile) {
                if ((e.keyCode || e.which) === tabKey || enterKey) {
                    menu.on.tabDesktop(e, menu.revers, e.keyCode);
                }

                if ((e.keyCode || e.which) === escKey) {
                    menu.on.escDesktop(e);
                }
            }
        });
    };

    menu.on.listPosition.start = function (direction) {
        if (!menu.nestedMenu || !direction || !menu.isMobile) return;
        let $firstNestedMenu = menu.nestedMenu.first();
        if (!$firstNestedMenu.closest('#menubar').length) return; // this function should only work inside #menubar

        switch (direction) {
            case 'in': {
                let $prevMenu = $firstNestedMenu.closest('.dropdown__menu, #menubar'),
                    $nextMenu = $firstNestedMenu.next('.dropdown__menu');

                if ($prevMenu.is('#menubar')) $prevMenu = $prevMenu.closest('.drawer__nav');
                if ($nextMenu.is('#menubar')) $nextMenu = $nextMenu.closest('.drawer__nav');

                menu.on.listPosition.handle(
                    {prev: $prevMenu, next: $nextMenu, parent: $prevMenu, sub: $nextMenu},
                    'in'
                );

                break;
            }
            case 'out': {
                let addDataOnly = $firstNestedMenu.hasClass('menu-header'),
                    $prevMenu = $firstNestedMenu.next('.dropdown__menu'),
                    $nextMenu = $firstNestedMenu.closest('.dropdown__menu, #menubar');

                if ($prevMenu.is('#menubar')) $prevMenu = $prevMenu.closest('.drawer__nav');
                if ($nextMenu.is('#menubar')) $nextMenu = $nextMenu.closest('.drawer__nav');

                menu.on.listPosition.handle(
                    {prev: $prevMenu, next: $nextMenu, parent: $nextMenu, sub: $prevMenu},
                    'out',
                    addDataOnly
                );

                break;
            }
        }
    };
    menu.on.listPosition.handle = function (menuElements, direction = {}, addDataOnly) {
        let timing = menu.mobileTransitionTime / 2,
            timeoutTime =
                direction === 'in' && menu.listPositionVars.inTimeoutTiming
                    ? menu.listPositionVars.inTimeoutTiming
                    : direction === 'out' && menu.listPositionVars.outTimeoutTiming
                    ? menu.listPositionVars.outTimeoutTiming
                    : menu.listPositionVars.mobileTransitionTime / 2;

        menu.on.listPosition.addDataToElem(menuElements.prev);
        if (addDataOnly === true) return;

        menu.on.listPosition.handleScrollBarHide([menuElements.prev, menuElements.next]);

        if (menuElements.next.length) {
            let lastScrollVal = menu.on.listPosition.getLastPosition(menuElements.next);

            setTimeout(() => {
                menu.on.listPosition.scrollTo(menuElements, direction, lastScrollVal ? lastScrollVal : 0, timing);
            }, timeoutTime); // a timeout so the transition happens just before the next list enters the viewport
        }
    };
    menu.on.listPosition.handleScrollBarHide = function (elemsArr) {
        elemsArr.forEach($elem => {
            $elem.attr('data-scrollbar-should-be-hidden', 'true');
            $elem.addClass('scrollbar-hidden');
        });
        if (elemsArr.length > 0) {
            let mainList = elemsArr[0].closest('.drawer__nav').attr('data-transitionend-listener-added', 'true');
            setTimeout(() => {
                mainList.find('[data-scrollbar-should-be-hidden="true"]').add(mainList).removeClass('scrollbar-hidden');
            }, menu.listPositionVars.mobileTransitionTime);
        }
    };
    menu.on.listPosition.scrollTo = function (menuElements, direction, value, timing = 0) {
        let parentHeightVal =
                menu.listPositionVars.mainScrollingListHeight -
                (menuElements.parent.innerHeight() - menuElements.parent.height()), // height minus padding
            subHeightVal =
                menu.listPositionVars.mainScrollingListHeight -
                (menuElements.sub.innerHeight() - menuElements.sub.height()); // height minus padding
        if (UX.utils.isSafari()) {
            subHeightVal = subHeightVal - 200;
        }
        if (direction === 'in') {
            menuElements.parent
                .css({'max-height': parentHeightVal, height: parentHeightVal, 'overflow-y': 'hidden'})
                .attr('data-list-pos-corrected', 'true');
            menuElements.sub
                .css({'max-height': subHeightVal, height: subHeightVal, 'overflow-y': 'auto'})
                .attr('data-list-pos-corrected', 'true');
            menuElements.sub
                .closest('.menu-parent')
                .css('overflow', 'visible')
                .attr('[data-list-pos-corrected-menu-parent="true"]');

            menuElements.parent.length &&
                menuElements.parent.animate(
                    {
                        scrollTop: 0, // if we don't scroll the parent to the top, the sub will sometimes be cut off
                    },
                    {
                        duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                    }
                );

            menuElements.sub.length &&
                menuElements.sub.animate(
                    {
                        scrollTop: value,
                    },
                    {
                        duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                    }
                );
        } else if (direction === 'out') {
            menuElements.parent.css({'max-height': parentHeightVal, height: parentHeightVal, 'overflow-y': 'auto'});
            menuElements.sub
                .css({'max-height': '', height: '', 'overflow-y': ''})
                .removeAttr('data-list-pos-corrected');
            menuElements.sub
                .closest('.menu-parent')
                .css({overflow: ''})
                .removeAttr('data-list-pos-corrected-menu-parent');

            menuElements.parent.length &&
                menuElements.parent.animate(
                    {
                        scrollTop: value,
                    },
                    {
                        duration: Math.abs(value - menuElements.parent.scrollTop()) > 125 ? 0 : timing,
                    }
                );
        }
    };
    menu.on.listPosition.reset = function () {
        menu.listPositionVars.mainScrollingList
            .find('[data-last-pos], [data-list-pos-corrected], [data-list-pos-corrected-menu-parent]')
            .add(menu.listPositionVars.mainScrollingList)
            .removeAttr('data-last-pos data-list-pos-corrected data-list-pos-corrected-menu-parent')
            .css({'max-height': '', height: '', 'overflow-y': ''})
            .animate(
                {
                    scrollTop: 0,
                },
                0
            );
    };
    menu.on.listPosition.handleResize = function (e) {
        if (menu.$toggle.hasClass('js--open')) {
            menu.on.listPosition.handleHeightSet({}, {skipCheck: true});
        }
    };
    menu.on.listPosition.handleHeightSet = function (e = {}, options = {}) {
        if (!menu.isMobile) return;
        if (
            (menu.$toggle.hasClass('js--open') &&
                e.elapsedTime === menu.listPositionVars.bodyTransitionElapsedTime &&
                e.propertyName === menu.listPositionVars.bodyTransitionPropertyName) ||
            options.skipCheck === true
        ) {
            // not using $window.outerHeight() because it's return value doesn't change with the resize event
            menu.listPositionVars.mainScrollingListHeight =
                window.outerHeight - menu.listPositionVars.mainScrollingList[0].getBoundingClientRect().top;
            menu.listPositionVars.mainScrollingList
                .find('[data-list-pos-corrected="true"]')
                .add(menu.listPositionVars.mainScrollingList)
                .css({
                    height: menu.listPositionVars.mainScrollingListHeight,
                    'max-height': menu.listPositionVars.mainScrollingListHeight,
                });
        }
    };
})(UX);
